import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';

@Component({
  selector: 'app-not-found',
  imports: [
      CommonModule,
      RouterModule
  ],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.css'
})
export class NotFoundComponent {
    constructor(private readonly router: Router) {}

    goBack() {
        this.router.navigate(['..']); // Navigates one level up in the route tree
    }

}
